import React from 'react';

export default {
	path: '/membership-terms',
	components: () => [import('./component')],
	render: ([MembershipTerms]) => <MembershipTerms />,
};
